import { ConditionalWrapperProps } from 'src/components/ConditionalWrapper/ConditionalWrapper.types';

const ConditionalWrapper: React.FC<ConditionalWrapperProps> = ({
  condition,
  wrapper,
  elseWrapper,
  children,
}) => {
  if (condition) {
    return wrapper(children);
  }
  if (elseWrapper) {
    return elseWrapper(children);
  }
  return children;
};

export default ConditionalWrapper;
